import { Routes } from '@angular/router';

import MainLayout from './components/main-layout/main-layout';
import { authGuard } from './guards/auth-guard';
import { profiliResolver } from './resolvers/profili-resolver';
import { profileGuard } from './guards/profile-guard';
import { permissionGuard } from './guards/permission-guard';
import { homeResolver } from './resolvers/home-resolver';
import { dettaglioDocumentoResolver } from './resolvers/dettaglio-documento.resolver';
import { ritrasmettiRichiestaNuovoInvioResolver } from './resolvers/ritrasmetti-richiesta-nuovo-invio.resolver';
import { caricaDocumentoRichiestaNuovoInvioResolver } from './resolvers/carica-documento-richiesta-nuovo-invio.resolver';
import { AppPermission } from './services/permission.service';

export const routes: Routes = [
  {
    path: 'profili',
    canActivate: [authGuard],
    loadComponent: () => import('./features/profili/profili'),
    resolve: { data: profiliResolver }
  },
  {
    path: '',
    component: MainLayout,
    canActivate: [authGuard, profileGuard],
    children: [
      {
        path: 'home',
        loadComponent: () => import('./features/home/home'),
        resolve: { profiliResolverData: homeResolver }
      },
      {
        path: 'assegnazione',
        loadComponent: () => import('./features/assegnazione/assegnazione'),
        data: { breadcrumb: 'Assegnazione' },
        children: [
              {
                path: '',
                redirectTo: 'gestione',
                pathMatch: 'full',
              },
              {
                path: 'gestione',
                data: { breadcrumb: 'Gestione assegnazione' },
                loadComponent: () => import('./features/assegnazione/gestione-assegnazioni/gestione-assegnazioni'),
                pathMatch: 'full',
              },
              {
                path: 'elaborazioni',
                data: { breadcrumb: 'Creazione e Assegnazioni' },
                children: [
                  {
                    path: '',
                    loadComponent: () => import('./features/assegnazione/creazione-elaborazione-assegnazioni/creazione-elaborazione-assegnazioni'),
                    pathMatch: 'full',
                  },
                  {
                    path: 'crea',
                    loadComponent: () => import('./features/assegnazione/creazione-elaborazione-assegnazioni/stepper-crea-assegnazione/stepper-crea-assegnazione'),
                    data: {
                      breadcrumb: 'Crea Assegnazione',
                      featureTitle: 'Crea Assegnazione',
                      featureSubtitle: 'sottotitolo',
                    },
                  },
                ],
              },
         ]
      },
      {
        path: 'istruttoria',
        loadComponent: () => import('./features/istruttoria/istruttoria'),
        data: { breadcrumb: 'Istruttoria' },
      },
      {
        path: 'documenti-adempimenti',
        loadComponent: () => import('./features/documenti-adempimenti/documenti-adempimenti'),
        data: {
          breadcrumb: 'Documenti',
          featureTitle: 'Documenti',
          featureSubtitle: 'Gestione Documenti adempimenti e allegati',
        },
        children: [
          {
            path: '',
            loadComponent: () => import('./features/documenti-adempimenti/documenti-adempimenti-tabs/documenti-adempimenti-tabs'),
            data: {
              featureTitle: 'Documenti',
              featureSubtitle: 'Gestione Documenti adempimenti e allegati',
            },
            children: [
              {
                path: '',
                redirectTo: 'gestione',
                pathMatch: 'full',
              },
              {
                path: 'gestione',
                data: {
                  breadcrumb: 'Gestione Documenti',
                  featureTitle: 'Documenti',
                  featureSubtitle: 'Gestione Documenti adempimenti e allegati',
                },
                children: [
                  {
                    path: '',
                    loadComponent: () => import('./features/documenti-adempimenti/gestione-documenti/gestione-documenti'),
                    pathMatch: 'full',
                  },
                  {
                    path: 'carica-nuovo-documento',
                    loadComponent: () => import('./features/documenti-adempimenti/gestione-documenti/carica-nuovo-documento/carica-nuovo-documento'),
                    data: {
                      breadcrumb: 'Carica Nuovo Documento',
                      featureTitle: 'Carica Nuovo Documento',
                      featureSubtitle: 'Compila i campi per caricare un nuovo documento nel sistema',
                    },
                  },
                  {
                    // Da lista: Gestione / Ricarica file documento (senza voce Dettaglio).
                    // Dichiarata prima di `:seqDocumento` per non essere catturata dal param.
                    path: 'ricarica-file/:seqDocumento',
                    loadComponent: () => import('./features/documenti-adempimenti/gestione-documenti/ricarica-file-documento/ricarica-file-documento'),
                    data: {
                      breadcrumb: 'Ricarica file documento',
                      featureTitle: 'Ricarica file documento',
                      featureSubtitle: 'Carica il file da inviare',
                    },
                    resolve: { dettaglioDocumento: dettaglioDocumentoResolver },
                  },
                  {
                    // Da lista: Gestione / Richiesta Nuovo Invio (senza voce Dettaglio).
                    // Dichiarata prima di `:seqDocumento` per non essere catturata dal param.
                    path: 'richiedi-nuovo-invio/:seqDocumento',
                    loadComponent: () => import('./features/documenti-adempimenti/gestione-documenti/richiedi-nuovo-invio/richiedi-nuovo-invio'),
                    data: {
                      breadcrumb: 'Richiesta Nuovo Invio',
                      featureTitle: 'Richiesta Nuovo Invio',
                      featureSubtitle: 'Compila i campi per richiedere un nuovo invio del documento',
                    },
                    resolve: { dettaglioDocumento: dettaglioDocumentoResolver },
                  },
                  {
                    // Da elenco documenti: Gestione Documenti / Dettaglio richiesta.
                    // Indietro → lista documenti (GO_BACK_RULES). Prima di `:seqDocumento`.
                    path: 'dettaglio-richiesta-nuovo-invio/:sequRichiesta',
                    loadComponent: () => import('./features/documenti-adempimenti/richieste-nuovo-invio/dettaglio-richiesta-nuovo-invio/dettaglio-richiesta-nuovo-invio'),
                    data: {
                      breadcrumb: 'Dettaglio richiesta',
                      featureTitle: 'Dettaglio richiesta',
                      featureSubtitle: 'Visualizza tutte le informazioni dettagliate della richiesta selezionata',
                    },
                  },
                  {
                    path: ':seqDocumento',
                    data: {
                      breadcrumb: 'Dettaglio Documento',
                    },
                    children: [
                      {
                        path: '',
                        loadComponent: () => import('./features/documenti-adempimenti/gestione-documenti/dettaglio-documento/dettaglio-documento'),
                        data: {
                          featureTitle: 'Dettaglio Documento',
                          featureSubtitle: 'Visualizza tutte le informazioni dettagliate del documento selezionato',
                          showDetailHeaderActions: true,
                        },
                        resolve: { dettaglioDocumento: dettaglioDocumentoResolver },
                      },
                      {
                        path: 'allegati',
                        loadComponent: () => import('./features/documenti-adempimenti/gestione-documenti/dettaglio-documento/dettaglio-documento'),
                        data: {
                          featureTitle: 'Dettaglio Documento',
                          featureSubtitle: 'Visualizza tutte le informazioni dettagliate del documento selezionato',
                          showDetailHeaderActions: true,
                        },
                        resolve: { dettaglioDocumento: dettaglioDocumentoResolver },
                      },
                      {
                        path: 'allegati/:sequAllegato/ricarica',
                        loadComponent: () => import('./features/documenti-adempimenti/gestione-documenti/ricarica-file-allegato/ricarica-file-allegato'),
                        data: {
                          breadcrumb: 'Ricarica file allegato',
                          featureTitle: 'Ricarica file allegato',
                          featureSubtitle: 'Carica il file da inviare',
                        },
                        resolve: { dettaglioDocumento: dettaglioDocumentoResolver },
                      },
                      {
                        path: 'carica-allegato',
                        loadComponent: () => import('./features/documenti-adempimenti/gestione-documenti/carica-nuovo-allegato/carica-nuovo-allegato'),
                        data: {
                          breadcrumb: 'Carica Allegato',
                          featureTitle: 'Carica Allegato',
                          featureSubtitle: 'Carica un allegato che verrà associato al documento principale',
                        },
                      },
                      {
                        // Da dettaglio: Gestione Documenti / Dettaglio Documento / Ricarica file documento.
                        path: 'ricarica-file',
                        loadComponent: () => import('./features/documenti-adempimenti/gestione-documenti/ricarica-file-documento/ricarica-file-documento'),
                        data: {
                          breadcrumb: 'Ricarica file documento',
                          featureTitle: 'Ricarica file documento',
                          featureSubtitle: 'Carica il file da inviare',
                        },
                        resolve: { dettaglioDocumento: dettaglioDocumentoResolver },
                      },
                      {
                        // Da dettaglio: Gestione Documenti / Dettaglio Documento / Richiesta Nuovo Invio.
                        path: 'richiedi-nuovo-invio',
                        loadComponent: () => import('./features/documenti-adempimenti/gestione-documenti/richiedi-nuovo-invio/richiedi-nuovo-invio'),
                        data: {
                          breadcrumb: 'Richiesta Nuovo Invio',
                          featureTitle: 'Richiesta Nuovo Invio',
                          featureSubtitle: 'Compila i campi per richiedere un nuovo invio del documento',
                        },
                        resolve: { dettaglioDocumento: dettaglioDocumentoResolver },
                      },
                    ],
                  },
                ],
              },
              {
                path: 'solleciti',
                loadComponent: () => import('./features/documenti-adempimenti/sollecito-per-inadempienza/sollecito-per-inadempienza'),
                data: {
                  breadcrumb: 'Sollecito per Inadempienza',
                  featureTitle: 'Documenti',
                  featureSubtitle: 'Gestione Solleciti per inadempienza',
                },
              },
              {
                path: 'richieste-nuovo-invio',
                data: {
                  breadcrumb: 'Richieste nuovo invio',
                  featureTitle: 'Documenti',
                  featureSubtitle: 'Gestione Richieste nuovo invio di documenti',
                },
                children: [
                  {
                    path: '',
                    loadComponent: () => import('./features/documenti-adempimenti/richieste-nuovo-invio/richieste-nuovo-invio'),
                    pathMatch: 'full',
                  },
                  {
                    path: ':sequRichiesta/ritrasmetti',
                    canActivate: [permissionGuard],
                    loadComponent: () => import('./features/documenti-adempimenti/richieste-nuovo-invio/ritrasmetti-richiesta-nuovo-invio/ritrasmetti-richiesta-nuovo-invio'),
                    data: {
                      breadcrumb: 'Ritrasmetti',
                      featureTitle: 'Ritrasmetti richiesta',
                      featureSubtitle: 'Compila i campi per ritrasmettere la richiesta di nuovo invio',
                      permission: AppPermission.RITRASMISSIONE_RICHIESTA_NUOVO_INVIO,
                      permissionRedirect: '/documenti-adempimenti/richieste-nuovo-invio',
                    },
                    resolve: { ritrasmetti: ritrasmettiRichiestaNuovoInvioResolver },
                  },
                  {
                    path: ':sequRichiesta/carica-documento',
                    canActivate: [permissionGuard],
                    loadComponent: () => import('./features/documenti-adempimenti/richieste-nuovo-invio/carica-documento-richiesta-nuovo-invio/carica-documento-richiesta-nuovo-invio'),
                    data: {
                      breadcrumb: 'Carica documento',
                      featureTitle: 'Carica documento',
                      featureSubtitle: 'Compila i campi per caricare un nuovo documento nel sistema',
                      permission: AppPermission.CARICA_DOCUMENTO,
                      permissionRedirect: '/documenti-adempimenti/richieste-nuovo-invio',
                    },
                    resolve: { caricaDocumento: caricaDocumentoRichiestaNuovoInvioResolver },
                  },
                  {
                    path: ':sequRichiesta',
                    loadComponent: () => import('./features/documenti-adempimenti/richieste-nuovo-invio/dettaglio-richiesta-nuovo-invio/dettaglio-richiesta-nuovo-invio'),
                    data: {
                      breadcrumb: 'Dettaglio richiesta',
                      featureTitle: 'Dettaglio richiesta',
                      featureSubtitle: 'Visualizza tutte le informazioni dettagliate della richiesta selezionata',
                    },
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        path: 'questionari',
        loadComponent: () => import('./features/questionari/questionari'),
        data: { breadcrumb: 'Questionari' },
      },
      {
        path: 'dossier-ente',
        loadComponent: () => import('./features/dossier-ente/dossier-ente'),
        data: { breadcrumb: 'Dossier Ente' },
      },
      {
        path: 'agenda',
        loadComponent: () => import('./features/agenda/agenda'),
        data: { breadcrumb: 'Agenda' },
      },
      {
        path: 'servizi-utili',
        loadComponent: () => import('./features/servizi-utili/servizi-utili'),
        data: { breadcrumb: 'Servizi utili' },
      },
      { path: '**', redirectTo: '/home' },
    ],
  },
];
